import React from 'react';
import { useTranslation } from 'react-i18next';
import { N8NLogo, ZapierLogo, MakeLogo } from './PlatformLogos';
import {
  ComparisonCard as StyledCard,
  ComparisonHeader,
  LogoContainer,
  ComparisonLogo,
  ComparisonLogoWrapper,
  PlatformName,
  VsBadge,
  ComparisonList,
  ComparisonItem,
  ComparisonIcon,
  ComparisonText
} from './styles';

interface Competitor {
  name: string;
  logo: string;
  loopraFeatures: string[];
  competitorFeatures: string[];
}

interface ComparisonCardProps {
  competitor: Competitor;
  delay: number;
  isVisible: boolean;
}

const ComparisonCard: React.FC<ComparisonCardProps> = ({ competitor, delay, isVisible }) => {
  const renderLogo = () => {
    switch (competitor.name) {
      case 'N8N':
        return <N8NLogo />;
      case 'Zapier':
        return <ZapierLogo />;
      case 'Make':
        return <MakeLogo />;
      default:
        return null;
    }
  };

  return (
    <StyledCard $delay={delay} $isVisible={isVisible}>
      <ComparisonHeader $isVisible={isVisible}>
        <LogoContainer>
          <ComparisonLogo src="/icons/loopra_icon_profile.webp" alt="Loopra" />
          <PlatformName>Loopra</PlatformName>
        </LogoContainer>
        <VsBadge>vs</VsBadge>
        <LogoContainer>
          <ComparisonLogoWrapper>
            {renderLogo()}
          </ComparisonLogoWrapper>
          <PlatformName>{competitor.name}</PlatformName>
        </LogoContainer>
      </ComparisonHeader>

      <ComparisonList>
        {competitor.loopraFeatures.map((feature, index) => (
          <ComparisonItem key={index} $type="loopra" $isVisible={isVisible} $index={index}>
            <ComparisonIcon $type="loopra">✓</ComparisonIcon>
            <ComparisonText dangerouslySetInnerHTML={{ __html: feature }} />
          </ComparisonItem>
        ))}

        {competitor.competitorFeatures.map((feature, index) => (
          <ComparisonItem
            key={index + competitor.loopraFeatures.length}
            $type="competitor"
            $isVisible={isVisible}
            $index={index + competitor.loopraFeatures.length}
          >
            <ComparisonIcon $type="competitor">◆</ComparisonIcon>
            <ComparisonText>
              <strong>{competitor.name}:</strong> {feature}
            </ComparisonText>
          </ComparisonItem>
        ))}
      </ComparisonList>
    </StyledCard>
  );
};

export default ComparisonCard;
